enum OperationType{
    create,
    read,
    update,
    delete,
}

export default OperationType;